"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleHoverTip = exports.TitleTip = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
/**
 * titleTips
 * @returns
 */
function TitleTip(props) {
    var _a = (0, react_1.useState)(false), show = _a[0], setShow = _a[1];
    var toggleTip = function () { return setShow(function (v) { return !v; }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "qa_tip_b" },
            react_1.default.createElement("em", { className: "icon_qa_tit", onMouseOver: toggleTip, onMouseLeave: toggleTip }),
            show && react_1.default.createElement("span", { className: "qa_tips" }, props.txt))));
}
exports.TitleTip = TitleTip;
/**
 * icon鼠标hover title气泡
 * @param props
 * @returns
 */
function TitleHoverTip(props) {
    var _a, _b;
    var _c = (0, react_1.useState)(false), show = _c[0], setShow = _c[1];
    var toggleTip = function () { return setShow(function (v) { return !v; }); };
    var width = ((_a = props.width) !== null && _a !== void 0 ? _a : 10) + 'px';
    var top = ((_b = props.top) !== null && _b !== void 0 ? _b : 10) + 'px';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "qa_tip_b" },
            react_1.default.createElement("em", { className: props.icon, onMouseOver: toggleTip, onMouseLeave: toggleTip }),
            show && react_1.default.createElement("span", { className: "qa_tips", style: { maxWidth: width, top: top } }, props.txt))));
}
exports.TitleHoverTip = TitleHoverTip;
